import { computed, inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SchedulerStepService {

  protected router = inject(Router)

  settings = signal<any>({})
  payload = signal<Record<string, any>>({})
  services = signal<Record<string, ServiceType>>({})
  branchSelected = signal<Branch>({} as Branch)

  branchView = computed( () => {
    return Object.keys(this.branchSelected()).length === 0
  } )
  
  steps = signal<Step[]>(
    [
      { complete: false, order: 1, mapping: 'services', live:true },
      { complete: false, order: 2, mapping: 'calendar' },
      { complete: false, order: 3, mapping: 'contact-info' }
    ] as Step[]
  )
  searchQuery = signal<string>('');

  actualStep = computed(() => {
    // Simply return the order of the currently live step
    const liveStep = this.steps().find(step => step.live);
    return liveStep ? liveStep.order : 1;
  } )
  
  totalStep =  this.steps().length



  constructor () {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      const pathSegments = event.url.split('/');

      const stepMapping = this.steps().find(item => pathSegments[1].includes(item.mapping!))

      if(event.url.includes('/service')){
        this.steps.update((prev) => prev.map(step => (step.mapping === 'calendar') ? ({...step, complete: false, live: false}) : ({...step, live: false})))
        if(this.payload()['services'] !== undefined){
          this.payload.update( (prev) => ({services: prev['services']}))
        }
      }

      // Special handling for calendar route - needed for schedule conflict recovery
      if(event.url.includes('/calendar')) {
        const hasServiceData = this.payload()['services'] !== undefined;
        const hasBranchData = Object.keys(this.branchSelected()).length > 0;
        
        this.steps.update(steps => steps.map(step => {
          if (step.mapping === 'services') {
            return { ...step, complete: hasServiceData && hasBranchData, live: false };
          } else if (step.mapping === 'calendar') {
            return { ...step, live: true, complete: false };
          } else {
            return { ...step, live: false };
          }
        }));
        return;
      }

      if (!stepMapping) return;

      const updatedSteps = this.steps().map(step => {
        // Preserve completion status for steps that have data
        const hasData = this.payload()[step.mapping!];
        const isCurrentStep = step.order === stepMapping.order;
        return {
          ...step,
          // Keep step complete if it has data, regardless of current route
          complete: hasData ? true : (isCurrentStep ? false : step.complete),
          live: isCurrentStep
        };
      });
    
      this.steps.set(updatedSteps);
      
    });
  }

  setPayload(key:string, value: CategorySelected, skip:boolean=false) {

    let val:any = value

    if (key !== 'contact-info' && key !== 'category'){
      val = value.description
    }

    if(this.payload()[key] == undefined || this.payload()[key] !== val){
      this.steps.update( steps => {
        return steps.map(step => {

          if(this.payload()[key] !== val && this.payload()[key] !== undefined){

          } else {
            const firstIncomplete = this.getFirstIncomplete()
            if (firstIncomplete.order+1 === step.order){
              step = { ...step, live: true }
            }
      
            if (step === firstIncomplete) {
              step = { ...step, live: false, complete: true }
            }
    
            if (skip) {
              step = { ...step, complete:true}
            }
          }

          
    
          return step
        })
      })
    }
    this.payload.set( {...this.payload(), [key]: val})
  }

  reset(){
    this.steps.set([
      { complete: false, order: 1, mapping: 'services', live:true },
      { complete: false, order: 2, mapping: 'calendar' },
      { complete: false, order: 3, mapping: 'contact-info' }
    ] as Step[])
  }

  getFirstIncomplete() {
    return this.steps().find(step => !step.complete)!;
  }

  getLastIncomplete() {
    return this.steps().find(item => item.complete === false);
  }

  getLastComplete() {
    return this.steps().reverse().find(item => item.complete === false);
  }

  getLatestComplete () {
    return this.steps().filter(step => step.complete).at(-1);
  }

  previousSteps () {
    const keys = Object.keys(this.payload());
    const lastKey = keys[keys.length - 1];
    if (lastKey) {
      const newObj = { ...this.payload() }; // Clone the object to avoid mutating original
      delete newObj[lastKey];
      this.payload.set(newObj); // Update the signal with new object
    }
  }
}
